import React, { useState } from 'react';
import { PolicyModal } from './PolicyModal';
export const Footer = () => {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const privacyContent = <div className="space-y-4" data-id="element-78">
      <h3 className="font-bold text-lg" data-id="element-79">1. Information We Collect</h3>
      <p data-id="element-80">
        We collect information you provide directly to us, such as when you
        request a quote, fill out a form, or communicate with us. This may
        include your name, email address, phone number, and property address.
      </p>
      <h3 className="font-bold text-lg" data-id="element-81">2. How We Use Your Information</h3>
      <p data-id="element-82">
        We use the information we collect to provide, maintain, and improve our
        services, to process your requests, and to communicate with you about
        your tree care needs.
      </p>
      <h3 className="font-bold text-lg" data-id="element-83">3. Information Sharing</h3>
      <p data-id="element-84">
        We do not sell or rent your personal information to third parties. We
        may share your information with service providers who perform services
        on our behalf.
      </p>
      <p className="text-sm text-gray-400 mt-8" data-id="element-85">Last updated: April 2026</p>
    </div>;
  const termsContent = <div className="space-y-4" data-id="element-86">
      <h3 className="font-bold text-lg" data-id="element-87">1. Services</h3>
      <p data-id="element-88">
        South Coast Tree Care agrees to perform the tree care services described
        in the accepted estimate or quote in a professional manner, using
        appropriate equipment and techniques.
      </p>
      <h3 className="font-bold text-lg" data-id="element-89">2. Scheduling and Weather</h3>
      <p data-id="element-90">
        While we strive to adhere to scheduled times, tree care is subject to
        weather conditions and emergencies. We reserve the right to reschedule
        services if conditions are unsafe.
      </p>
      <h3 className="font-bold text-lg" data-id="element-91">3. Liability</h3>
      <p data-id="element-92">
        We take every precaution to protect your property. However, we are not
        responsible for damage to underground utilities, pipes, or cables unless
        their exact locations were clearly marked prior to the commencement of
        work.
      </p>
      <p className="text-sm text-gray-400 mt-8" data-id="element-93">Last updated: April 2026</p>
    </div>;
  return <footer className="bg-charcoal text-white pt-20 pb-10" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-96">
          <div className="col-span-1 lg:col-span-2" data-id="element-97">
            <div className="flex items-center gap-3 mb-6" data-id="element-98">
              <img src="https://cdn.magicpatterns.com/uploads/wKYvS1cjpX9gsAXzBpZUZc/Photoroom_20260408_085127.png" alt="South Coast Tree Care Logo" className="h-20 w-auto object-contain" data-id="element-99" />
              <div data-id="element-100">
                <h2 className="text-2xl font-bold text-white" data-id="element-101">South Coast</h2>
                <p className="text-accent font-bold tracking-widest uppercase" data-id="element-102">
                  Tree Care
                </p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-md" data-id="element-103">
              Orange County's Complete Tree Care Specialists. Built to protect
              your property, beautify your yard, and give you total peace of
              mind.
            </p>
            <a href="mailto:southcoasttreecare@gmail.com" className="text-gray-400 hover:text-white transition-colors inline-flex items-center gap-2" data-id="element-104">
              ✉️ southcoasttreecare@gmail.com
            </a>
          </div>

          <div data-id="element-105">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-106">Legal</h3>
            <ul className="space-y-4" data-id="element-107">
              <li data-id="element-108">
                <button onClick={() => setIsPrivacyOpen(true)} className="text-gray-400 hover:text-white transition-colors" data-id="element-109">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-110">
                <button onClick={() => setIsTermsOpen(true)} className="text-gray-400 hover:text-white transition-colors" data-id="element-111">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-500 text-sm" data-id="element-112">
          <p data-id="element-113">
            © {new Date().getFullYear()} South Coast Tree Care. All rights
            reserved.
          </p>
        </div>
      </div>

      <PolicyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Privacy Policy" content={privacyContent} data-id="element-114" />
      <PolicyModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms of Service" content={termsContent} data-id="element-115" />
    </footer>;
};